import config from "../config";
import { actionTrackTypes } from "../enum/actionTrackTypes";
const { intercomMessengerId } = config;
export const ActionTrackForConsultations = async (
  actionType,
  currentUser,
  pharmacy,
  company
) => {
  const titleVal = actionTrackTypes[actionType] || "Consultation Action";

  if (typeof window !== "undefined" && typeof window.Intercom === "function") {
    // It's better to call "update" if Intercom is already booted

    window.Intercom("update", {
      app_id: intercomMessengerId,
      email: currentUser?.emailAddress,
      user_id: currentUser?.emailAddress, // Should be a unique user ID
      name: currentUser?.fullName,
    });

    // Track the event
    window.Intercom("trackEvent", "consultation-action", {
      title: titleVal,
      actionType: actionType,
      pharmacy: pharmacy?.teamPharmacyName,
      company: company?.companyName,
      user: currentUser?.emailAddress,
    });
  } else {
    console.warn("Intercom is not available or not loaded yet.");
  }
};
